import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nica-footer',
  templateUrl: './nica-footer.component.html',
  styleUrls: ['./nica-footer.component.css']
})
export class NicaFooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
